import { createRoot } from "react-dom/client";
import "./fonts/inter-latin-subset.css";
import "@fontsource-variable/outfit/index.css";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
